import {defineStore} from 'pinia'

import {SmartSearchConfig, SmartSearchTranslations} from "@/main";

export const useTitleStore = defineStore('TitleStore', {
    state: () => {
        return {}
    },
    actions: {
        changeTitle(query: string, resultsCount: number) {
            if (!SmartSearchConfig.value.serp.changeTitle.enabled) {
                return
            }
            let prefix, postfix = ''
            if (SmartSearchTranslations.value?.serp?.documentTitlePrefix !== null){
                prefix = SmartSearchTranslations.value.serp.documentTitlePrefix
            }
            if (SmartSearchTranslations.value?.serp?.documentTitlePostfix !== null){
                postfix = SmartSearchTranslations.value.serp.documentTitlePostfix
            }
            window.document.title = prefix + query + postfix
        }
    }
})
